import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Grid } from '@material-ui/core'
import TeethTrackingLegend from './TeethTrackingLegend'
import TeethGrid from './TeethGrid'
import useFeatureFlags from 'hooks/useFeatureFlags'
import usePlanLimits from 'hooks/usePlanLimits'
import { isRetentionStamp } from '../trackingStampUtils'

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    borderTop: '1px solid var(--border-color-37)',
    padding: 8,
    borderBottomLeftRadius: 32,
    borderBottomRightRadius: 32
  }
}))

const TeethTracking = ({ treatmentTrackerData, currentScan, scanNumber, treatmentType, disabled = false }) => {
  const classes = useStyles()
  const { txTrackerTxGoals, treatmentTracker } = useFeatureFlags()
  const { isTxTrackerEligible } = usePlanLimits()

  // The parsed result carries its own tracking stamp; the timeline card renders this
  // component without a currentScan, so the stamp must not be read off the scan.
  const isRetentionResult = isRetentionStamp(treatmentTrackerData)
  const isTxGoalsEnabled = !isRetentionResult && (isTxTrackerEligible || treatmentTracker || txTrackerTxGoals)

  return (
    <Grid container direction="column" justifyContent="center" wrap="nowrap" className={classes.container}>
      <Grid item>
        <TeethGrid
          teethData={treatmentTrackerData.teeth}
          isTxGoalsEnabled={isTxGoalsEnabled}
          currentScan={currentScan}
          scanNumber={scanNumber}
          treatmentType={treatmentType}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12}>
        <TeethTrackingLegend treatmentType={treatmentType} isRetentionResult={isRetentionResult} />
      </Grid>
    </Grid>
  )
}

export default TeethTracking
